module.exports = __webpack_public_path__ + "img/bg.13c72c85.png";